module.exports = __webpack_public_path__ + "img/德州银行.2737c685.png";